import * as yup from 'yup';

export const recordSchema = yup.object({
    reason: yup.string().label('reason').required('Este campo es requerido'),
    revelevant_clinic: yup.string().label('revelevant_clinic'),
    diagnosis: yup.string().label('diagnosis').required('Este campo es requerido'),
});

export type recordSchemaType = yup.InferType<typeof recordSchema>
